module.exports = __webpack_public_path__ + "static/media/left-arrow-blue-back.0c8ec829.svg";